import createCache from '@emotion/cache';
import { isGtmDebugMode } from './isGtmDebugMode';

const createEmotionCache = () => {
    if (isGtmDebugMode()) {
        // Disable Stylis plugins for debugging to avoid CSS processing
        return createCache({ key: 'gtm-debug', stylisPlugins: [] });
    }
    return createCache({ key: 'css', prepend: true });
};

export default createEmotionCache;
